var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "15px",
    height: "15px",
    viewBox: "25 25 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.8626887131560028s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(27.692307692307693 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.7907979870596693s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(55.38461538461539 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.7189072609633357s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(83.07692307692308 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.6470165348670022s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(110.76923076923077 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.5751258087706685s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(138.46153846153845 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.503235082674335s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(166.15384615384616 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.4313443565780014s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(193.84615384615384 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.35945363048166784s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(221.53846153846155 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.2875629043853343s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(249.23076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.2156721782890007s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(276.9230769230769 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.14378145219266714s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(304.61538461538464 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "-0.07189072609633357s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(332.3076923076923 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.5,
    y: 28.5,
    rx: 0,
    ry: 0,
    width: 3,
    height: 9,
    fill: "#1D1E30"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "0.9345794392523364s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.8bf115a648fd9d045f6cbc1c4e5d4ecf.svg";
export { ForwardRef as ReactComponent };